import React from 'react'
import { TabContent, TabPane } from 'reactstrap'
import SchoolLookUp from 'components/SchoolLookUp'
import Admin from '../AssignAdmin'
import Confirm from '../AssignConfirm'
import { SchoolLookUpSiteData } from 'types'
import { Steps } from '../hooks/useAssignFormState'

interface AdminData {
  email: string
  confirmEmail: string
}

interface ConfirmData {
  isConfirmed: boolean
}

interface StepContentProps {
  activeTab: number
  schoolData: SchoolLookUpSiteData
  email: string
  defaultAdminEmail?: string
  onStepChange: (data: SchoolLookUpSiteData | AdminData | ConfirmData) => void
}

const StepContent: React.FC<StepContentProps> = ({
  activeTab,
  schoolData,
  email,
  defaultAdminEmail,
  onStepChange,
}) => {
  return (
    <TabContent activeTab={activeTab}>
      <TabPane className="lst-step" tabId={Steps.School}>
        <br />
        <SchoolLookUp
          onSelection={onStepChange}
          siteData={schoolData}
          fireOnLoad={false}
        />
      </TabPane>
      <TabPane className="lst-step" tabId={Steps.LicenseAdmin}>
        <br />
        <Admin defaultAdminEmail={defaultAdminEmail} onSelect={onStepChange} />
      </TabPane>
      <TabPane className="lst-step" tabId={Steps.Confirm}>
        <br />
        <Confirm
          email={email}
          onSelect={onStepChange}
          schoolName={
            schoolData.netsuiteCustomerId
              ? schoolData.companyName
              : schoolData.organizationName
          }
        />
      </TabPane>
    </TabContent>
  )
}

export default StepContent
